import type { IRegexSerializer } from '../interface/regex';

function _replacer(key: unknown, value: any) {
    if (value instanceof RegExp) return '__REGEXP ' + value.toString();
    else return value;
}

function _reviver(key: unknown, value: any) {
    if (value.toString().indexOf('__REGEXP ') === 0) {
        const m = value.split('__REGEXP ')[1].match(/\/(.*)\/(.*)?/);
        return new RegExp(m[1], m[2] || '');
    } else {
        return value;
    }
}

function stringify(regex: RegExp): string {
    return JSON.stringify(regex, _replacer, 2);
}

function parse(regex: string): RegExp {
    return JSON.parse(regex, _reviver);
}

const module: IRegexSerializer = {
    stringify,
    parse,
};

export default module;
